import { TaskScopeNameEnum } from 'graphql-common';

export default function getEmptyStateTextKeys(tab?: string) {
  switch (tab) {
    case TaskScopeNameEnum.Failure:
      return ['no-tasks-failure-yet', 'no-tasks-failure-text'];
    case TaskScopeNameEnum.Warning:
      return ['no-tasks-warning-yet', 'no-tasks-warning-text'];
    case TaskScopeNameEnum.Success:
      return ['no-tasks-success-yet', 'no-tasks-success-text'];
    default:
      return ['no-tasks-yet', 'no-tasks-text'];
  }
}
